import { hslaWithAlpha, primitiveTokens } from "@appretio/ui-kit";
import { globalStyle, style } from "@vanilla-extract/css";

export const container = style({
  display: "flex",
  flexDirection: "column",
  gap: primitiveTokens.sizing["4x"]
});

export const tableSection = style({
  display: "flex",
  flexDirection: "column",
  gap: primitiveTokens.sizing["1x"]
});

export const tableLabel = style({
  fontSize: primitiveTokens.type.sm,
  fontWeight: 600
});

/* Center group headers — override AG Grid's sticky left positioning */
globalStyle(`${container} .ag-header-group-cell-label.ag-sticky-label`, {
  position: "static",
  flex: "1",
  justifyContent: "center"
});

/* Green/red flash colors for ChangeFlashCell */
globalStyle(`${container} .ag-value-change-delta-up`, {
  color: `${primitiveTokens.colors.green[500]} !important`
});

globalStyle(`${container} .ag-value-change-delta-down`, {
  color: `${primitiveTokens.colors.red[500]} !important`
});

globalStyle(`${container} .ag-value-change-value-highlight`, {
  backgroundColor: `${hslaWithAlpha(primitiveTokens.colors.green[500], 0.3)} !important`
});
